import BaseCookie from './BaseCookie'

export default class BridesCookie extends BaseCookie {
   static KEYS = {
      cookieAgree: 'cookieAgree',
      subscribed: 'subscribed',
   }

   static getInstance() {
      if (!this.instance) {
         this.instance = new BridesCookie()
      }
      return this.instance
   }

   static setCookieAgree(value = true, options = {}) {
      BridesCookie.getInstance().setCookie(BridesCookie.KEYS.cookieAgree, value, options)
   }

   static getCookieAgree() {
      return BridesCookie.getInstance().getCookie(BridesCookie.KEYS.cookieAgree)
   }

   static setSubscribed(value = true, options = {}) {
      BridesCookie.getInstance().setCookie(BridesCookie.KEYS.subscribed, value, options)
   }

   static getSubscribed() {
      return BridesCookie.getInstance().getCookie(BridesCookie.KEYS.subscribed)
   }
}